import { SelectEditorDescription_Type } from "@smartsuite/automation-engine-api";

export const selectOptionMatchesStoredValue = (
  optionValue: string,
  storedValue: string,
  selectType: SelectEditorDescription_Type | undefined,
): boolean => {
  if (optionValue === storedValue) return true;
  if (selectType !== SelectEditorDescription_Type.DROPDOWN_WITH_DETAILS) {
    return false;
  }
  return extractSlug(optionValue) === extractSlug(storedValue);
};

/**
 * For {@link SelectEditorDescription_Type.DROPDOWN_WITH_DETAILS}, API option `value`
 * is JSON while the form often stores a plain identifier — compare on slug/value when possible.
 */
const extractSlug = (value: string): string => {
  try {
    const parsed: unknown = JSON.parse(value);
    if (typeof parsed === "object" && parsed !== null) {
      const record = parsed as { slug?: unknown; value?: unknown };
      if (typeof record.slug === "string") return record.slug;
      if (typeof record.value === "string") return record.value;
    }
  } catch {
    // value is a plain identifier, not JSON
  }
  return value;
};
